import React, { useContext, useReducer, useCallback } from "react";

const SelectedTestsContext = React.createContext(null);

const initialState = { selected: {}, selectedResultCaveatIds: [], selectedSampleIds: [] };

function selectedTestsReducer(state, action) {
  switch (action.type) {
    case "reset":
      return initialState;
    case "clearSelected":
      return { ...state, selected: {} };
    case "toggle":
      var sampleId = action.sampleId;
      var sampleTestId = action.sampleTestId;
      var selected = state.selected[sampleId] || [];
      selected = selected.includes(sampleTestId)
        ? selected.filter(id => id !== sampleTestId)
        : selected.concat(sampleTestId);
      return { ...state, selected: { ...state.selected, [sampleId]: selected } };
      break;
    case "toggleForSample":
      var sampleId = action.sampleId;
      var sampleTestIds = action.sampleTestIds;
      var select = action.select;
      if (select) {
        return { ...state, selected: { ...state.selected, [sampleId]: sampleTestIds } };
      } else {
        return { ...state, selected: { ...state.selected, [sampleId]: [] } };
      }
      break;
    case "toggleCaveat":
      var resultCaveatId = action.resultCaveatId;
      var selected = action.selected;
      if (selected) {
        return {
          ...state,
          selectedResultCaveatIds: [resultCaveatId, ...state.selectedResultCaveatIds]
        };
      } else {
        return {
          ...state,
          selectedResultCaveatIds: state.selectedResultCaveatIds.filter(
            id => id !== resultCaveatId
          )
        };
      }
    case "unSelectAllSamples":
      return { ...state, selectedSampleIds: [] };
    case "selectSample":
      var sampleId = action.sampleId;
      var selected = action.selected;
      if (selected) {
        return {
          ...state,
          selectedSampleIds: [sampleId, ...state.selectedSampleIds]
        };
      } else {
        return {
          ...state,
          selectedSampleIds: state.selectedSampleIds.filter(id => id !== sampleId)
        };
      }
    default:
      return state;
  }
}

const useSelectedTests = () => {
  const { state, dispatch } = useContext(SelectedTestsContext);
  const toggleTest = useCallback(
    ({ sampleId, sampleTestId }) =>
      dispatch({
        type: "toggle",
        sampleId,
        sampleTestId
      }),
    [dispatch]
  );
  const clear = useCallback(() => dispatch({ type: "clearSelected" }), [dispatch]);
  const resetSelected = useCallback(() => dispatch({ type: "reset" }), [dispatch]);
  const toggleForSample = useCallback(
    ({ sampleId, sampleTestIds, select }) =>
      dispatch({
        type: "toggleForSample",
        sampleId,
        sampleTestIds,
        select
      }),
    [dispatch]
  );
  const selectedTestCount = Object.keys(state.selected)
    .map(key => state.selected[key].length)
    .reduce((a, b) => a + b, 0);
  const selectedSampleTestIds = Object.keys(state.selected)
    .map(key => state.selected[key])
    .reduce((a, b) => a.concat(b), []);
  const unselectAllSamples = useCallback(
    () =>
      dispatch({
        type: "unSelectAllSamples"
      }),
    [dispatch]
  );

  // const selectSample = useCallback(
  //   ({ sampleId, selected }) =>
  //     dispatch({
  //       type: "selectSample",
  //       sampleId,
  //       selected
  //     }),
  //   [dispatch]
  // );
  return {
    selectedTests: state,
    selectedSampleTestIds,
    selectedTestCount,
    toggleTest,
    clear,
    resetSelected,
    toggleForSample,
    unselectAllSamples
  };
};

const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(selectedTestsReducer, undefined, () => initialState);
  const value = { state, dispatch };
  return (
    <SelectedTestsContext.Provider value={value}>{children}</SelectedTestsContext.Provider>
  );
};

export default SelectedTestsContext;
export { selectedTestsReducer, useSelectedTests, Provider };
